import { render, staticRenderFns } from "./InstallmentTab.vue?vue&type=template&id=6a845376&lang=pug&"
import script from "./InstallmentTab.vue?vue&type=script&lang=ts&"
export * from "./InstallmentTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports